import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import SlideBar from '@components/SlideBar';
import Text from '@components/Text';
import colors from '@constants/colors';
import usePriceUnit from '@hooks/item/usePriceUnit';
import useShop from '@hooks/shop/useShop';
import useAppCustom from '@hooks/useAppCustom';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import usePrepareOrder from '@store/order/hooks/usePrepareOrder';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

function PurchaseFooter() {
    const { t } = useTranslation('order');
    const [buttonMessage] = useState(t('footer.slidePayment'));
    const prepareOrder = usePrepareOrder();
    const {
        shopName, totalDiscount, paymentAmount, totalAmount, shopId,
    } = useCalculatedRequest();
    const shop = useShop(shopId);
    const { paymentButtonType } = useAppCustom().payment;
    const priceUnit = usePriceUnit();

    return (
        <Column as='footer' className={styles.container}
            fullWidth
            spacing={16} >
            <Column spacing={8} fullWidth>
                <Row justify='space-between' fullWidth>
                    <Text color={colors.gray6} fontWeight='bold'
                        size='lg' >
                        {t('footer.productAmount')}
                    </Text>
                    <Text size='lg' >
                        {totalAmount.toLocaleString()}{priceUnit}
                    </Text>
                </Row>
                <Row justify='space-between' fullWidth>
                    <Text color={colors.gray6} fontWeight='bold'
                        size='lg' >
                        {t('footer.discountAmount')}
                    </Text>
                    <Text size='lg' >
                        -{totalDiscount.toLocaleString()}{priceUnit}
                    </Text>
                </Row>
                <Row justify='space-between' fullWidth>
                    <Text fontWeight='bold'
                        size='xl' >
                        {t('footer.paymentAmount')}
                    </Text>
                    <Text size='3xl' fontWeight='bold' color={colors.red} >
                        {paymentAmount.toLocaleString()}{priceUnit}
                    </Text>
                </Row>
            </Column>
            {shop?.orderStatus === 'OPEN' ? (
                <Fragment>
                    {paymentButtonType === 'SLIDE' ? (
                        <SlideBar onConfirm={prepareOrder}>
                            {buttonMessage}
                        </SlideBar>
                    ) : (
                        <Button onClick={prepareOrder}
                            fullWidth >
                            {t('footer.payment')}
                        </Button>
                    )}

                </Fragment>
            ) : (
                <Button disabled fullWidth>
                    {t('footer.preparing')}
                </Button>
            )}
        </Column>
    );
}

export default PurchaseFooter;
